import React, { Component } from 'react';
import { Card, Avatar, message, Input, List, Breadcrumb } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
// import FavButton from '../../components/FavButton';
import axios from 'axios';
import Configuration from '../../Configuration';
const { Meta } = Card;
const Search = Input.Search;

class Warehouse extends Component {
  constructor() {
    super();
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.state = {redirect: false, warehouse: {name: '', status: true, visit_tickets: [], branch: {id: 1, name: ''}}, filteredTickets: []};
    this.validateToken = this.validateToken.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
    this.getWarehouse = this.getWarehouse.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getWarehouse();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});
    
    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin"))
      this.setState({redirect: true});
  }

  getWarehouse() {
    const id = this.props.match.params.id;

    axios.get(`${Configuration.apiServer}/api/v1/warehouses/${id}`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({warehouse: resp.data, filteredTickets: resp.data.visit_tickets});
    });
  }

  handleStatus(id) {
    axios.put(`${Configuration.apiServer}/api/v1/warehouses/${id}/status`, {}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      message.success('Registro actualizado')
      this.getWarehouse();
    });
  }

  handleSearch(event) {
    const visit_tickets = this.state.warehouse.visit_tickets.filter(ticket => {
      return ticket.driver.name.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1
    });

    this.setState({filteredTickets: visit_tickets});
  }
  
  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    // Render component
    return (
      <div>
        <PublicMenu />
        
        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex flex-row flex-start">
            <Breadcrumb>
              <Breadcrumb.Item> <a href="/admin/warehouses">Sucursales</a> </Breadcrumb.Item>
              <Breadcrumb.Item>{this.state.warehouse.name}</Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <br/>

          <div className="d-flex flex-row flex-wrap justify-content-between">
            <div style={{ width: '30%', padding: '0px 10px' }}>
              <Search placeholder="Buscar..." onChange={this.handleSearch} style={{ width: '100%' }} />

              <br/><br/>

              <Card
                style={{ width: '100%', margin: '0px' }}
              >
                <Meta
                  avatar={<Avatar icon="solution" />}
                  title={this.state.warehouse.name}
                  description={<span className={`cursor text-${Configuration.getStatus(this.state.warehouse.status).color}`} onClick={() => { this.handleStatus(this.state.warehouse.id) }}>{Configuration.getStatus(this.state.warehouse.status).text}</span>}
                />
                <p className="text-muted" style={{ marginBottom: '0px', marginLeft: '45px', marginTop: '5px' }}>En sucursal {this.state.warehouse.branch.name}</p>
              </Card>
            </div>

            <div style={{ width: '70%', padding: '0px 10px' }}>
              <List
                itemLayout="horizontal"
                dataSource={this.state.filteredTickets}
                renderItem={ticket => (
                  <List.Item>
                    <List.Item.Meta
                      avatar={<Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />}
                      title={<a href="https://ant.design">{ticket.driver.name}</a>}
                      description={`Transportista ${ticket.carrier.name} | Camión ${ticket.truck.plates}`}
                    />
                  </List.Item>
                )}
              />
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default Warehouse;



// WEBPACK FOOTER //
// ./src/pages/admin/Warehouse.js